import styled from "styled-components";
import { Button as AntButton, Form as AntForm } from "antd";

export const ChangePinContainer = styled.div`
	min-height: calc(100vh - 110px);
	display: flex;
	align-items: center;
	flex-direction: column;

	.ant-form-item-label {
		text-align: center;
		font-size: 16px;
	}

	.ant-input {
		text-align: left;
	}
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
  margin-top: 16px;
	position: relative !important;

	.ant-form-item {
		margin: 0 auto 28px ;
		width: calc(100% - 32px);
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label {
		margin: 0 auto;
    width: 100%;
		margin-left: 18px;
    text-align: left !important;
	}

	.ant-form-item-label label {
    color: #004F9C;
		font-size: 14px;
		font-weight: 400;
		line-height: 21px;
	}

	.ant-form-item-explain {
		text-align: left; 
		margin-left: 24px;
		margin-top: 2px;
	}
`;

export const ChangePinTitle = styled.p`
	color: #000000;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 25px; 
	text-align: center;
`;

export const Button = styled(AntButton)`
	width: 100%;
	height: 52px !important;
	border-radius: 26px !important;
	box-sizing: border-box !important ;
	color: #f7f7f7;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	margin-top: 50px;
`;

export const TitleWrapper = styled.div`
	background-color: #DEEDFF;
	padding: 16px 0;
	width: 100%;
`;
